import { createContext, useContext, ReactNode } from 'react'

interface CustomerInfoType {
  // 定义customerInfo的类型
  id?: string
  name?: string
  birthday?: string
  pin?: string
  channelId?: string[]
  createdBy?: string
  createdTime?: number
  exactAge?: number
  gender?: string
  lastFollowTime?: number
  lastUpdatedTime?: number
  orgIds?: string[]
  orgNames?: string[]
  phone?: number
  wechatNo?: string
  tags?: any[]
  contactPersonList?: any[]
  age?: number,
  contactPhone?: number
  contactId?: string
}

interface CustomerContextType {
  customerInfo: CustomerInfoType
  setCustomerInfo?: (info: CustomerInfoType) => void
  loading?: boolean
  customerSourceList?: any[]
}

const CustomerContext = createContext<CustomerContextType>({ customerInfo: {} })

export const CustomerProvider = ({ 
  children, 
  value 
}: { 
  children: ReactNode
  value: CustomerContextType 
}) => {
  return (
    <CustomerContext.Provider value={value}>
      {children}
    </CustomerContext.Provider>
  )
}

// 自定义hook方便使用
export const useCustomerInfo = () => useContext(CustomerContext)
